import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrl;
const API_VERSION = environment.MSUserVersion;
const SERVICE = 'msuser-dot-';
const requestURL = 'https://' + API_VERSION + SERVICE + API_URL;

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private http: HttpClient) { }

  create(role: any) {
    return this.http.post(requestURL + `/role`, role);
  }

  update(role: any) {
    return this.http.put(requestURL + `/role`, role);
  }

  delete(id: number) {
    return this.http.delete(requestURL + `/role/` + id);
  }

  getById(id: number) {
    return this.http.get(requestURL + `/role/` + id);
  }

  getAll() {
    return this.http.get(requestURL + `/role/retrieve-all`);
  }
}